import React from "react";
import { Segment } from "semantic-ui-react";
import { SEMANTIC_DIV } from "../../../css/styles";
import { Link } from "react-router-dom";

export default function TextLink({
  text,
  className = "text-link",
  to,
  fontSize = 17,
  extraStyles,
  action,
  ...props
}) {
  return (
    <span onClick={action}>
      <Segment
        style={{ ...SEMANTIC_DIV, fontSize: fontSize, ...extraStyles }}
        basic
        as={Link}
        className={className}
        to={to}
        {...props}
      >
        {text}
      </Segment>
    </span>
  );
}
